 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","2":"default~profile-my-profile-communication-settings-my-profile-communication-settings-module~profile-m~870841bd","3":"angular-common-locales-fi","4":"angular-common-locales-sv","5":"angular-common-locales-sv-FI","6":"app-app-module","7":"contracts-my-contracts-view-my-contracts-view-module","8":"elements-dialog-dialog-module","9":"elements-energy-source-banner-energy-source-banner-module","10":"elements-energy-source-submitter-energy-source-submitter-module","11":"elements-input-input-module","12":"elements-postalcode-gridarea-consumption-redirect-postalcode-gridarea-consumption-redirect-module","13":"elements-postalcode-gridarea-postalcode-gridarea-module","14":"flows-electrical-products-filter-electrical-products-filter-module","15":"flows-flows-acquisition-business-sweden-checkout-flows-acquisition-business-sweden-checkout-module","16":"flows-flows-acquisition-business-sweden-confirmation-flows-acquisition-business-sweden-confirmation-module","17":"flows-flows-acquisition-private-sweden-checkout-flows-acquisition-private-sweden-checkout-module","18":"flows-flows-acquisition-private-sweden-confirmation-flows-acquisition-private-sweden-confirmation-module","19":"flows-flows-change-contract-sweden-checkout-flows-change-contract-sweden-checkout-module","20":"flows-flows-change-contract-sweden-confirmation-flows-change-contract-sweden-confirmation-module","21":"flows-flows-confirmation-contract-section-flows-confirmation-contract-section-module","22":"flows-flows-confirmation-renewal-section-flows-confirmation-renewal-section-module","23":"flows-flows-contract-details-section-flows-contract-details-section-module","24":"flows-flows-customer-details-section-flows-customer-details-section-module","25":"flows-flows-fi-renewal-checkout-flows-fi-renewal-checkout-module","26":"flows-flows-fi-renewal-confirmation-flows-fi-renewal-confirmation-module","27":"flows-flows-fi-renewal-contact-section-flows-fi-renewal-contact-section-module","28":"flows-flows-fi-renewal-login-flows-fi-renewal-login-element-module","29":"flows-flows-fi-renewal-product-select-section-flows-fi-renewal-product-select-option-flows-fi-renewal-product-select-option-module","30":"flows-flows-fi-renewal-product-select-section-flows-fi-renewal-product-select-section-module","31":"flows-flows-invoice-method-section-flows-invoice-method-section-module","32":"flows-flows-move-acquisition-private-switch-flows-move-acquisition-private-switch-module","33":"flows-flows-move-acquisition-switch-flows-move-acquisition-switch-module","34":"flows-flows-move-business-sweden-checkout-flows-move-business-sweden-checkout-module","35":"flows-flows-move-business-sweden-confirmation-flows-move-business-sweden-confirmation-module","36":"flows-flows-move-private-sweden-checkout-flows-move-private-sweden-checkout-module","37":"flows-flows-move-private-sweden-confirmation-flows-move-private-sweden-confirmation-module","38":"flows-flows-new-contract-details-section-flows-new-contract-details-section-module","39":"flows-flows-new-contract-section-flows-new-contract-section-module","40":"flows-flows-premise-contract-summary-flows-premise-contract-summary-module","41":"flows-flows-premises-select-flows-premises-select-module","42":"flows-flows-product-addons-section-flows-product-addons-section-module","43":"flows-flows-product-details-section-flows-product-details-section-module","44":"flows-flows-product-select-section-flows-product-select-option-flows-product-select-option-module","45":"flows-flows-product-select-section-flows-product-select-section-module","46":"flows-flows-submit-contract-section-flows-submit-contract-section-module","47":"flows-flows-submit-renewal-section-flows-submit-renewal-section-module","48":"flows-my-select-consumption-interval-form-my-select-consumption-interval-form-module","49":"flows-my-select-electricity-product-my-select-electricity-product-module","50":"heat-calculator-area-selector-area-selector-module","51":"heat-calculator-b2b-calculator-input-b2b-calculator-input-module","52":"heat-calculator-b2b-calculator-result-section-b2b-calculator-result-section-module","53":"heat-calculator-b2c-calculator-b2c-calculator-module","54":"heat-calculator-price-section-price-section-module","57":"profile-my-contact-notification-dialog-my-contact-notification-dialog-module","58":"profile-my-profile-communication-settings-my-profile-communication-settings-module","59":"profile-my-profile-detail-view-my-profile-detail-view-module","60":"samples-lazy-loading-module","62":"widgets-my-widgets-consumption-overview-my-widgets-consumption-overview-module","63":"widgets-my-widgets-contract-price-my-widgets-contract-price-module","64":"widgets-my-widgets-electricity-price-now-my-widgets-electricity-price-now-module","65":"widgets-my-widgets-invoice-overview-my-widgets-invoice-overview-module","66":"widgets-my-widgets-premise-details-my-widgets-premise-details-module","67":"widgets-my-widgets-static-light-yellow-my-widgets-static-light-yellow-module","68":"widgets-my-widgets-static-white-my-widgets-static-white-module","69":"widgets-my-widgets-static-yellow-my-widgets-static-yellow-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["vattenfallElements"] = window["vattenfallElements"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
